import { manutencao_da_estrutura_curricular_para_supletivo } from "./manutencao-estrutura-curricular-para-supletivo";
import { associar_disciplinas_para_uma_estrutura_curricular_supletivo } from "./associar-disciplinas-para-uma-estrutura-curricular-supletivo";
import { associar_estrutura_curricular_a_escola } from "./associar-estrutura-curricular-a-escola";
import { manutencao_parametros_exame } from "./manutencao-parametros-do-exame";
import { manutencao_parametros_avaliacao_parcial } from "./parametros-avaliacao-parcial";
import { quantidade_minima_de_avaliacoes } from "./quantidade-minima-de-avaliacoes";

const manutencao_historico = [
  ...manutencao_parametros_exame,
  ...manutencao_da_estrutura_curricular_para_supletivo,
  ...associar_estrutura_curricular_a_escola,
  ...associar_disciplinas_para_uma_estrutura_curricular_supletivo,
  ...manutencao_parametros_avaliacao_parcial,
  ...quantidade_minima_de_avaliacoes,
];

export { manutencao_historico };
